import Model from '../utils/Model'

export class EdiType {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

// E2Open-星亚系统
export const E2_OPEN = 33

export const BOOKING_EDI_TYPE = new EdiType(1, '订舱', 'Booking')
export const BILL_EDI_TYPE = new EdiType(2, '提单', 'BL')
export const OVERSEA_EDI_TYPE = new EdiType(3, '海外代理预报', 'Overseas Agency Forecast')
export const INSTALL_EDI_TYPE = new EdiType(4, '安箱单', 'Packing list')
export const MAINFEST_EDI_TYPE = new EdiType(5, '舱单', 'Manifest')
export const SHIPPING_EDI_TYPE = new EdiType(6, '预配舱单', 'PreloadingManifest')
export const CLAER_EDI_TYPE = new EdiType(7, '清洁舱单', 'Clean Manifest')
export const AFR_EDI_TYPE = new EdiType(8, '反恐舱单', 'Anti-terrorism Manifest')
export const SUITCASE_EDI_TYPE = new EdiType(30, '提箱状态', 'CTNRDrawingStatus')
export const EDI_TYPE_DECARTS = new EdiType(12, 'Decarts', 'decarts')
export const KIN_NIT_EDI_TYPE = new EdiType(31, '海外代理预报-荆艺系统', '海外代理预报-荆艺系统')
export const BC_EDI_TYPE = new EdiType(32, '订舱回执', '订舱回执')
export const AK_EDI_TYPE = new EdiType(33, '通讯回执A', '通讯回执A')
export const RL_EDI_TYPE = new EdiType(34, '通讯回执C', '通讯回执C')
export const EDI_CONFIRM_TYPE = new EdiType(35, '订舱确认回执', '订舱确认回执')
export const EDI_COMMUNICATE_TYPE = new EdiType(36, '订舱通信回执', '订舱通信回执')
export const EDI_BL_COMMUNICATE_TYPE = new EdiType(37, '提单通信回执', '提单通信回执')
export const IFTMAN_EDI = new EdiType(9, '海运进口分拨舱单', '海运进口分拨舱单')
export const AMS = new EdiType(10, 'AMS', 'AMS')
export const VGM = new EdiType(11, 'VGM', 'VGM')
export const VGM_13 = new EdiType(13, 'VGM', 'VGM')
export const LADING_MSC_BILL_EDI = new EdiType(14, 'msi bill', 'msi bill')
export const CARGOWISE_XML_EDI = new EdiType(15, 'CargoWise bill', 'CargoWise bill')
export const VGM2_MANIFESTINFO_EDI = new EdiType(23, 'VGM', 'VGM')
export const PRECONFIGURE_MANIFESTINFO_EDI = new EdiType(26, '预配舱单', '预配舱单')
export const IFCSUM_MANIFESTINFO_EDI = new EdiType(27, '清洁舱单', '清洁舱单')
export const VESSEL_XML_EDI = new EdiType(28, 'Vessel', 'Vessel')
export const CONTAINERS_EDI = new EdiType(29, '装箱数据', 'Packing information')
export const CANCELLATION_EDI = new EdiType(30, '取消订舱', 'Cancel booking')
export const BOOOKING_CANCEL = new EdiType(90, '订舱取消回执', 'Booking Cancel')
export const ENS = new EdiType(38, 'ENS', 'ENS')
export const ACI = new EdiType(39, 'ACI', 'ACI')
export const ISF = new EdiType(40, 'ISF', 'ISF')
export const E_MANIFEST = new EdiType(41, 'eManifest', 'eManifest')
export const ENS_OTHER = new EdiType(42, 'ENS', 'ENS')
export const JCL_EDI_TYPE = new EdiType(43, 'JCL', 'JCL')

export const BILL_TYPES = [
  BOOKING_EDI_TYPE, BILL_EDI_TYPE, OVERSEA_EDI_TYPE, INSTALL_EDI_TYPE,
  MAINFEST_EDI_TYPE, SHIPPING_EDI_TYPE, CLAER_EDI_TYPE, AFR_EDI_TYPE,
  SUITCASE_EDI_TYPE, KIN_NIT_EDI_TYPE, BC_EDI_TYPE, AK_EDI_TYPE, RL_EDI_TYPE
]

export const ALL_BILL_TYPES = [
  BOOKING_EDI_TYPE, BILL_EDI_TYPE, OVERSEA_EDI_TYPE, INSTALL_EDI_TYPE,
  MAINFEST_EDI_TYPE, SHIPPING_EDI_TYPE, CLAER_EDI_TYPE, AFR_EDI_TYPE,
  SUITCASE_EDI_TYPE, KIN_NIT_EDI_TYPE, BC_EDI_TYPE, AK_EDI_TYPE, RL_EDI_TYPE,
  IFTMAN_EDI, AMS, VGM, EDI_TYPE_DECARTS, VGM_13, LADING_MSC_BILL_EDI, CARGOWISE_XML_EDI,
  VGM2_MANIFESTINFO_EDI, PRECONFIGURE_MANIFESTINFO_EDI, IFCSUM_MANIFESTINFO_EDI, VESSEL_XML_EDI,
  EDI_CONFIRM_TYPE, EDI_COMMUNICATE_TYPE, EDI_BL_COMMUNICATE_TYPE, BOOOKING_CANCEL, CONTAINERS_EDI, CANCELLATION_EDI, ENS, ACI, ISF, E_MANIFEST, JCL_EDI_TYPE
]

export function getEdiTypeByCode(code) {
  return Model.getObjByCode(code, ALL_BILL_TYPES)
}
